






























import Vue from 'vue'
import Component from 'vue-class-component'
import subscriptionValues, { TierInfo } from '@/model/SubscriptionValues'

@Component
export default class SubscriptionPricingTable extends Vue {
    monthlyTiers: TierInfo[] = subscriptionValues.monthlyTiers
    yearlyTiers: TierInfo[] = subscriptionValues.yearlyTiers

    isConstantPerUser(): boolean {
        return this.monthlyTiers.length === 1
    }

    getCellUsers(index: number): string {
        const upTo = this.monthlyTiers[index].upTo
        if (index === 0)
            return upTo?.toString() || ''

        const prevUpTo = this.monthlyTiers[index-1].upTo!
        if (upTo === null)
            return `${prevUpTo+1}+`

        return `${prevUpTo+1} to ${upTo}`
    }

    getPriceText(price: number): string {
        return subscriptionValues.getPriceText(price)
    }
}
